import { render, staticRenderFns } from "./SummaryLine.vue?vue&type=template&id=d4848140&"
import script from "./SummaryLine.vue?vue&type=script&lang=ts&"
export * from "./SummaryLine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports